import { render, staticRenderFns } from "./Whoms.vue?vue&type=template&id=ae078222&"
import script from "./Whoms.vue?vue&type=script&lang=js&"
export * from "./Whoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports